import React, { useState, useEffect } from 'react';
import { getServices } from '../../api/services';
import './Services.css';

function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getServices().then(res => {
      if (res.success) setServices(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return (
    <section className="section services-section">
      <div className="container">Loading...</div>
    </section>
  );

  const displayed = services.slice(0, 4);

  return (
    <section id="services" className="section services-section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">What We Offer</span>
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">Comprehensive landscaping solutions tailored to your needs</p>
        </div>
        <div className="services-grid">
          {displayed.length === 0
            ? <p className="no-data">No services added yet.</p>
            : displayed.map((service) => (
              <div key={service.id} className="service-card">
                <div className="service-icon">{service.icon_class || '🌿'}</div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-desc">{service.short_desc}</p>
                <a href={`/services/${service.slug}`} className="service-link">Learn More →</a>
              </div>
            ))
          }
        </div>
        {services.length > 4 && (
          <div className="section-footer">
            <a href="/services" className="btn-outline">
              View All Services ({services.length})
            </a>
          </div>
        )}
      </div>
    </section>
  );
}

export default Services;